import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import {
  addEmployeeAction,
  editEmployeeAction,
  fetchEmployeesAction,
  deleteEmployeeAction,
} from "../redux/actions/employeeActions";
import { Employee as EmployeeType } from "../types/Employee";

import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import Modal from "../components/Modal";
import EmployeeForm from "../components/EmployeeForm";
import CollapseCard from "../components/custom/CollapseCard";
import EmployeeList from "../components/EmployeeList";
import { useToast } from "../components/toast/ToastProvider";
import { StoreState } from "../redux/reducers";
import { Button, Form, Row, Col } from "react-bootstrap";

const Employee = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useToast();

  const employeeList = useSelector((state: StoreState) => state.employee);
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeType | null>(
    null,
  );
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(fetchEmployeesAction()).finally(() => setLoading(false));
  }, [dispatch]);

  const handleEdit = (employee: EmployeeType) => {
    setSelectedEmployee(employee);
    setShowModal(true);
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState<EmployeeType[]>(
    [],
  );

  useEffect(() => {
    if (!searchQuery) {
      setFilteredEmployees([]);
      return;
    }
    const query = searchQuery.toLowerCase();
    const results = employeeList.filter((emp) =>
      emp.employeeId.toLowerCase().includes(query),
    );
    setFilteredEmployees(results);
  }, [searchQuery, employeeList]);

  const employeesToShow = searchQuery ? filteredEmployees : employeeList;

  const addOrUpdateHandler = async (data: EmployeeType) => {
    setLoading(true);
    try {
      let payload = { ...data };
      if (selectedEmployee) {
        if (
          !payload.password ||
          payload.password === selectedEmployee.password
        ) {
          delete payload.password;
        }
      }

      if (selectedEmployee) {
        await dispatch(editEmployeeAction(data.id, payload));

        toast("Employee updated successfully");
      } else {
        await dispatch(addEmployeeAction(payload));
        toast("Employee created successfully");
      }
      await dispatch(fetchEmployeesAction());
      setSelectedEmployee(null);
      setViewMode(false);
      setShowModal(false);
    } catch (error) {
      toast("Error in Save Employee");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure?")) {
      setLoading(true);
      await dispatch(deleteEmployeeAction(id));
      toast("Employee deleted successfully");
      await dispatch(fetchEmployeesAction());
      setLoading(false);
    }
  };

  const handleViewDetails = (employee: EmployeeType) => {
    setSelectedEmployee(employee);
    setViewMode(true);
    setShowModal(true);
  };

  return (
    <Main>
      <PageContainer
        title="Employee"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedEmployee(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        {/* Search input */}
        <Row className="mb-3 mt-5">
          <Col md={4}>
            <Form.Group controlId="search">
              {/* <Form.Label>
              search
            </Form.Label> */}
              <Form.Control
                type="text"
                className="form-control"
                placeholder="Search by Employee ID "
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Modal
          visible={showModal}
          size="xl"
          onClose={() => {
            setShowModal(false);
            setSelectedEmployee(null);
            setViewMode(false);
          }}
          headerText={
            viewMode
              ? "View Employee"
              : selectedEmployee
                ? "Update Employee"
                : "Add Employee"
          }
        >
          <EmployeeForm
            employeeIdToEdit={selectedEmployee?.id}
            onSave={addOrUpdateHandler}
            initialData={selectedEmployee}
            readOnly={viewMode}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => setViewMode(false)}
              >
                Edit
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="Employee List">
          <EmployeeList
            employeeList={employeesToShow}
            // employeeList={employeeList}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleViewDetails}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Employee;
